type ReportUiStateInput = {
  readonly responseOk: boolean
  readonly threw: boolean
  readonly hadBatches: boolean
  readonly completed: boolean
}

export type ReportUiState = 'ready' | 'empty' | 'error'

/**
 * Pure function that maps fetch outcome to the final report UI state.
 *
 * - Any HTTP error or thrown exception → error
 * - Stream truncated (sentinel absent) → error
 * - Sentinel present + data received → ready
 * - Sentinel present + no data → empty
 */
export const resolveReportUiState = ({
  responseOk,
  threw,
  hadBatches,
  completed
}: ReportUiStateInput): ReportUiState => {
  if (!responseOk) {
    return 'error'
  }

  if (threw) {
    return 'error'
  }

  if (!completed) {
    return 'error'
  }

  if (hadBatches) {
    return 'ready'
  }

  return 'empty'
}
